export enum ScheduledTaskState {
    Enabled = 'Enabled',
    Disabled = 'Disabled',
}
